export const FETCH_PERMISSIONS = 'FETCH_PERMISSIONS'
export const NEW_PERMISSION = 'NEW_PERMISSION'
export const UPDATE_PERMISSION = 'UPDATE_PERMISSION'
export const DELETE_PERMISSION = 'DELETE_PERMISSION'
export const AUTH_LOGIN = 'AUTH_LOGIN'
export const AUTH_LOGOUT = 'AUTH_LOGOUT'
